/**
 * Detects if Prerender.io user agent
 * @see https://docs.prerender.io/v1/docs/33-overview-of-prerender-crawlers
 */
const getIsPrerenderUserAgent = () => typeof navigator !== 'undefined' && /prerender/i.test(navigator.userAgent);
export default getIsPrerenderUserAgent;